import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts, type BlogPost } from '../blogPosts';

export const BlogList: React.FC = () => {
  const [featured, ...rest] = blogPosts;

  return (
    <div className="bg-slate-50 min-h-screen">
      <section className="border-b border-slate-200 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 lg:py-14">
          <p className="text-xs font-semibold uppercase tracking-wide text-primary mb-2">
            Blog · Nettoyage logement insalubre, Diogène et nettoyage extrême
          </p>
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-3">
            Articles de blog sur le nettoyage de logements insalubres 06 / 83
          </h1>
          <p className="text-sm text-slate-600 max-w-3xl">
            Conseils pratiques, exemples concrets, fourchettes de prix et retours d'expérience
            pour les logements insalubres, le syndrome de Diogène, le nettoyage extrême et les
            interventions dans les Alpes Maritimes (06) et le Var (83).
          </p>
        </div>
      </section>

      <section className="border-b border-slate-200 bg-slate-900 text-white">
        <div className="max-w-6xl mx-auto px-4 py-5 lg:py-6 flex flex-wrap items-center gap-3 text-[11px]">
          <p className="font-semibold text-slate-100">
            Vous cherchez un prix ou un devis après la lecture des articles ?
          </p>
          <div className="flex flex-wrap gap-2">
            <Link
              to="/tarifs"
              className="inline-flex items-center justify-center rounded-md border border-slate-500 px-3 py-1.5 font-medium text-slate-100 hover:bg-slate-800 transition-colors"
            >
              Voir les tarifs nettoyage logement insalubre
            </Link>
            <Link
              to="/devis"
              className="inline-flex items-center justify-center rounded-md border border-slate-500 px-3 py-1.5 font-medium text-slate-100 hover:bg-slate-800 transition-colors"
            >
              Demander un devis 06 / 83
            </Link>
            <Link
              to="/nice-06"
              className="inline-flex items-center justify-center rounded-md border border-slate-500 px-3 py-1.5 font-medium text-slate-100 hover:bg-slate-800 transition-colors"
            >
              Nettoyage logement insalubre à Nice
            </Link>
            <Link
              to="/var-toulon"
              className="inline-flex items-center justify-center rounded-md border border-slate-500 px-3 py-1.5 font-medium text-slate-100 hover:bg-slate-800 transition-colors"
            >
              Nettoyage logement insalubre Var / Toulon
            </Link>
          </div>
        </div>
      </section>

      {featured && (
        <section className="max-w-6xl mx-auto px-4 pt-8 lg:pt-10">
          <article className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm grid gap-0 lg:grid-cols-2">
            <Link
              to={`/blog/${featured.slug}`}
              className="block h-full max-h-80 overflow-hidden"
            >
              <img
                src={featured.image}
                alt={featured.imageAlt}
                className="h-full w-full object-cover"
                loading="lazy"
              />
            </Link>
            <div className="p-5 lg:p-7 flex flex-col">
              <p className="text-[11px] uppercase tracking-wide text-primary font-semibold mb-2">
                Article en avant
                {featured.city ? ` · ${featured.city}` : ''}
              </p>
              <Link
                to={`/blog/${featured.slug}`}
                className="hover:text-primary transition-colors"
              >
                <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3">
                  {featured.title}
                </h2>
              </Link>
              <p className="text-sm text-slate-600 mb-4">{featured.description}</p>
              <div className="mt-auto flex items-center justify-between text-[11px] text-slate-500 mb-3">
                <span>{featured.readingTime} de lecture</span>
                <span>{featured.publishedAt}</span>
              </div>
              <div className="flex flex-wrap gap-2 text-[11px]">
                <Link
                  to={`/blog/${featured.slug}`}
                  className="inline-flex items-center justify-center rounded-md border border-slate-300 px-3 py-1.5 font-medium text-slate-700 hover:bg-slate-100 transition-colors"
                >
                  Lire l'article
                </Link>
                {featured.city === 'Nice' && (
                  <Link
                    to="/nice-06"
                    className="inline-flex items-center justify-center rounded-md border border-slate-300 px-3 py-1.5 font-medium text-slate-700 hover:bg-slate-100 transition-colors"
                  >
                    Service nettoyage à Nice
                  </Link>
                )}
                {featured.city === 'Toulon' && (
                  <Link
                    to="/var-toulon"
                    className="inline-flex items-center justify-center rounded-md border border-slate-300 px-3 py-1.5 font-medium text-slate-700 hover:bg-slate-100 transition-colors"
                  >
                    Service nettoyage Var / Toulon
                  </Link>
                )}
              </div>
            </div>
          </article>
        </section>
      )}

      <section className="max-w-6xl mx-auto px-4 py-10 lg:py-14">
        <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-4">
          Tous nos articles sur le nettoyage logement insalubre
        </h2>
        <div className="grid gap-6 md:grid-cols-2">
          {rest.map((post: BlogPost) => (
            <article
              key={post.slug}
              className="flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
            >
              <Link to={`/blog/${post.slug}`} className="block">
                <img
                  src={post.image}
                  alt={post.imageAlt}
                  className="h-44 w-full object-cover"
                  loading="lazy"
                />
              </Link>
              <div className="flex-1 p-4 flex flex-col">
                <p className="text-[11px] uppercase tracking-wide text-primary font-semibold mb-1">
                  {post.category}
                  {post.city ? ` · ${post.city}` : ''}
                </p>
                <Link
                  to={`/blog/${post.slug}`}
                  className="hover:text-primary transition-colors"
                >
                  <h2 className="text-base font-semibold text-slate-900 mb-2">
                    {post.title}
                  </h2>
                </Link>
                <p className="text-xs text-slate-600 mb-3 line-clamp-3">
                  {post.description}
                </p>
                <div className="mt-auto flex flex-col gap-2 text-[11px] text-slate-500">
                  <div className="flex items-center justify-between">
                    <span>{post.readingTime} de lecture</span>
                    <span>{post.publishedAt}</span>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    <Link
                      to={`/blog/${post.slug}`}
                      className="inline-flex items-center justify-center rounded-md border border-slate-300 px-3 py-1.5 font-medium text-slate-700 hover:bg-slate-100 transition-colors"
                    >
                      Lire l'article
                    </Link>
                    {post.city === 'Nice' && (
                      <Link
                        to="/nice-06"
                        className="inline-flex items-center justify-center rounded-md border border-slate-300 px-3 py-1.5 font-medium text-slate-700 hover:bg-slate-100 transition-colors"
                      >
                        Service nettoyage à Nice
                      </Link>
                    )}
                    {post.city === 'Toulon' && (
                      <Link
                        to="/var-toulon"
                        className="inline-flex items-center justify-center rounded-md border border-slate-300 px-3 py-1.5 font-medium text-slate-700 hover:bg-slate-100 transition-colors"
                      >
                        Service nettoyage Var / Toulon
                      </Link>
                    )}
                    {post.category === 'Tarifs' && (
                      <Link
                        to="/tarifs"
                        className="inline-flex items-center justify-center rounded-md border border-slate-300 px-3 py-1.5 font-medium text-slate-700 hover:bg-slate-100 transition-colors"
                      >
                        Voir la page tarifs
                      </Link>
                    )}
                    {post.category === 'Devis' && (
                      <Link
                        to="/devis"
                        className="inline-flex items-center justify-center rounded-md border border-slate-300 px-3 py-1.5 font-medium text-slate-700 hover:bg-slate-100 transition-colors"
                      >
                        Aller au formulaire de devis
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};
